import React, { useEffect } from "react";
import "./VisionMission.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

const VisionMission = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true
    });
  }, []);

  return (
    <section className="vm_page">
      {/* HEADER SECTION */}
      <div className="vm_header">
        <h1>{t('vm.header_title')}</h1>
        <p>
          {t('vm.header_subtitle')} <strong>{t('brand.title')}</strong>.
        </p>
      </div>

      {/* PROBLEM + APPROACH SECTION */}
      <section className="vm_steps">
        <div className="vm_step vm_problem" data-aos="fade-right">
          <div className="vm_step_number">01</div>
          <h3>{t('vm.problem_title')}</h3>
          <p>{t('vm.problem_desc')}</p>
        </div>

        <div className="vm_step vm_approach" data-aos="fade-left">
          <div className="vm_step_number">02</div>
          <h3>{t('vm.approach_title')}</h3>
          <p>{t('vm.approach_desc')}</p>
        </div>
      </section>

      {/* VISION MISSION VALUES */}
      <section className="vm_cards_section">
        <h2 className="vm_cards_title">{t('vm.cards_section_title')}</h2>

        <div className="vm_cards_container">
          {/* MISSION */}
          <div className="vm_card vm_mission">
            <div className="vm_icon_circle">
              <img src={require("../../Asset/Images/mis1.png")} alt="Mission" />
            </div>
            <h3>{t('vm.mission_title')}</h3>
            <p>{t('vm.mission_desc')}</p>
          </div>

          {/* VISION */}
          <div className="vm_card vm_vision">
            <div className="vm_icon_circle">
              <img src={require("../../Asset/Images/vis1.png")} alt="Vision" />
            </div>
            <h3>{t('vm.vision_title')}</h3>
            <p>{t('vm.vision_desc')}</p>
          </div>

          {/* VALUES */}
          <div className="vm_card vm_values">
            <div className="vm_icon_circle">
              <img src={require("../../Asset/Images/val1.png")} alt="Values" />
            </div>
            <h3>{t('vm.values_title')}</h3>
            <p>{t('vm.values_desc')}</p>
          </div>
        </div>
      </section>
    </section>
  );
};

export default VisionMission;